// Глобальные настройки приложения — тема и язык
// Хранятся в localStorage, реактивно через событие

export type Theme = 'dark' | 'light'
export type Lang = 'ru' | 'en'

const THEME_KEY = 'app_theme'
const LANG_KEY = 'app_lang'

export function getTheme(): Theme {
  return (localStorage.getItem(THEME_KEY) as Theme) ?? 'dark'
}

export function getLang(): Lang {
  return (localStorage.getItem(LANG_KEY) as Lang) ?? 'ru'
}

export function setTheme(t: Theme): void {
  localStorage.setItem(THEME_KEY, t)
  window.dispatchEvent(new CustomEvent('app-settings-change'))
}

export function setLang(l: Lang): void {
  localStorage.setItem(LANG_KEY, l)
  window.dispatchEvent(new CustomEvent('app-settings-change'))
}

// Переводы UI
export const T: Record<string, Record<Lang, string>> = {
  search:    { ru: 'Поиск', en: 'Search' },
  publish:   { ru: 'Поездка', en: 'Ride' },
  map:       { ru: 'Карта', en: 'Map' },
  radio:     { ru: 'Рация', en: 'Radio' },
  profile:   { ru: 'Профиль', en: 'Profile' },
  driver:    { ru: 'Водитель', en: 'Driver' },
  passenger: { ru: 'Пассажир', en: 'Passenger' },
  settings:  { ru: 'Настройки', en: 'Settings' },
  theme_dark:  { ru: 'Тёмная', en: 'Dark' },
  theme_light: { ru: 'Светлая', en: 'Light' },
  edit:      { ru: 'Изменить', en: 'Edit' },
  cancel:    { ru: 'Отмена', en: 'Cancel' },
  anon:      { ru: 'Анонимный профиль', en: 'Anonymous profile' },
  as_driver: { ru: 'Как водитель', en: 'As driver' },
  as_pass:   { ru: 'Как пассажир', en: 'As passenger' },
  no_rides:  { ru: 'Поездок нет', en: 'No rides' },
  no_reqs:   { ru: 'Запросов нет', en: 'No requests' },
  loading:   { ru: 'Загрузка...', en: 'Loading...' },
  notif:     { ru: 'Уведомления о событиях', en: 'Event notifications' },
  voice:     { ru: 'Голосовые оповещения', en: 'Voice alerts' },
  on:        { ru: 'Вкл', en: 'On' },
}
